import type { TFunction } from "i18next";
import { DateTime } from "luxon";
import type { Department } from "../../contexts/AuthProvider";
import { getJobDisplayName } from "../../utils/roles";
import type { EmployeeChangeLogField } from "./useEmployeeChangelogQuery";

const formatValue = (val: unknown): string => {
	if (val === null || val === undefined) return "—";
	if (typeof val === "boolean") return val ? "Yes" : "No";
	if (val instanceof DateTime) return val.toFormat("MMM d, yyyy HH:mm");
	if (Array.isArray(val)) {
		return val
			.map((item) => {
				if (item instanceof DateTime) return item.toFormat("MMM d, yyyy");
				if (item !== null && typeof item === "object") return JSON.stringify(item);
				return String(item ?? "—");
			})
			.join(", ");
	}
	if (typeof val === "object") return JSON.stringify(val);
	return String(val);
};

const jobNames = (ids: unknown[], dept: Department): string => ids.map((id) => getJobDisplayName(String(id), dept) || "unfamiliar job").join(", ");

export const resolveFieldValue = (field: EmployeeChangeLogField, val: unknown, dept: Department, t: TFunction): string => {
	if (field === "job_ids" && Array.isArray(val)) {
		if (val.length === 0) return "—";
		return jobNames(val, dept);
	}
	// An empty silent list means every job notifies, so show "None" instead of a dash.
	if (field === "silent_job_ids" && Array.isArray(val)) {
		if (val.length === 0) return t("jobNotifications.changelog.none");
		return jobNames(val, dept);
	}
	return formatValue(val);
};
